import clsx from "clsx";
import { FC } from "react";
import { Row } from "react-table";
import Storefront from "../../../../../../models/Storefront";

type Props = {
  row: Row<Storefront>;
};

const CustomRow: FC<Props> = ({ row }) => (
  <tr {...row.getRowProps()}>
    {row.cells.map((cell) => {
      //{console.log("cell =====>>>>"+ JSON.stringify(cell))}
      return (
        <td
          {...cell.getCellProps()}
          className={clsx({
            "text-end min-w-100px": cell.column.id === "actions",
          })}
        >
          {cell.render("Cell")}
        </td>
      );
    })}
  </tr>
);

export { CustomRow };